import React from "react";
import { connect } from "react-redux";
import ListItemText, {
    Typography,
    IconButton,
    WithStyles,
    withStyles,
    ListItem,
    Grid,
    Button,
} from "material-ui";
import EditIcon from "material-ui-icons/ModeEdit";

import { ReduxState, ReduxDispatch } from "../../ducks/reducers";
import { Link } from "react-router-dom";
import { RouteProps, RouterProps } from "react-router";
import {
    SetActionButtonDisabled,
    ResetActionButtonClicked,
    SetShowActionButton,
    SetActionButtonAndShow,
    ActionButton,
    actionButtonClicked,
    actionButtonDisabled,
} from "../../ducks/actionbutton";
import {
    SetShowBackNavigation,
    ShowBackNavigationWithRoute,
    SetHeader,
} from "../../ducks/common";
import EditProfileForm, {
    editProfileFormName,
    EditProfileData,
    IEditProfileFormProps,
} from "./components/EditProfileForm";
import logger from "../../util/logger";
import { formValueSelector, InjectedFormProps, submit } from "redux-form";
import { IProfileDataDto } from "../../util/DTOs/ProfileDtos";
import { saveProfileData, fetchProfileData } from "../../ducks/profile";

const styles = {
    container: {
        paddingRight: 20,
        paddingLeft: 20,
        marginBottom: 60,
    },
    subheadingWeight: {
        fontWeight: "200",
    },
} as React.CSSProperties;

interface IProfilePageEditProps {}
interface IProfilePageEditReduxProps {
    name: string;
    phoneNumber: string;
    email: string;
    hasUserName: boolean;
    formValues: EditProfileData;

    isSaveClicked: boolean;
    isSaveButtonDisabled: boolean;
}
interface IProfilePageEditDispatchProps {
    submitProfileForm: () => Promise<void>;
    setHeader: (value: string) => void;
    setBackButton: (route: string) => void;
    hideBackButton: () => void;
    setActionButton: (button: ActionButton) => void;
    hideActionButton: () => void;
    resetActionButtonClick: () => void;
    disableActionButton: (disabled: boolean) => void;
    saveProfileData: (data: IProfileDataDto) => Promise<void>;
    fetchProfile: () => void;
}

interface ProfilePageEditState {
    isEditing: boolean;
}

type ProfilePageEditProps = IProfilePageEditProps &
    IProfilePageEditReduxProps &
    IProfilePageEditDispatchProps &
    RouterProps;

type ProfilePageEditPropsWithStyles = ProfilePageEditProps &
    WithStyles<"container" | "subheadingWeight">;

class EditProfilePage extends React.Component<
    ProfilePageEditPropsWithStyles,
    ProfilePageEditState
> {
    constructor(props: ProfilePageEditPropsWithStyles) {
        super(props);
        this.state = { isEditing: false };
    }

    componentDidMount() {
        this.props.setBackButton("/profile");
        let button: ActionButton = { text: "Tallenna", showSpinner: true };
        this.props.setActionButton(button);
        this.props.setHeader("");

        if (!this.props.name || !this.props.name.trim()) {
            this.props.fetchProfile();
        }
    }

    componentWillUnmount() {
        this.props.hideBackButton();
        this.props.hideActionButton();
        this.props.setHeader("");
    }

    componentWillReceiveProps(nextProps: ProfilePageEditPropsWithStyles) {
        if (nextProps.isSaveClicked) {
            this.props.submitProfileForm();
            this.props.resetActionButtonClick();
        }
    }

    saveProfile = async (data: EditProfileData) => {
        logger.log("save profile");
        let dto: IProfileDataDto = {
            email: data.email || "",
            phoneNumber: data.phoneNumber || "",
            streetAddress: data.streetAddress || "",
            postalCode: data.postalCode || "",
            hasLoginCredentials: false,
        };
        await this.props
            .saveProfileData(dto)
            .then(() => {
                this.props.resetActionButtonClick();
                this.props.history.push("/profile");
            })
            .catch((err) => {
                this.props.resetActionButtonClick();
                logger.error(err);
            });
    };

    render() {
        return this.renderEdit();
    }
    renderEdit() {
        return (
            <div className="page-container">
                <Grid container>
                    <Grid item xs={12} sm={10} md={10}>
                        <h1
                            className={"loginHeader"}
                            style={{ color: "#646363" }}
                        >
                            Omat tiedot
                        </h1>
                    </Grid>
                    <Grid item xs={12} sm={10} md={10}>
                        <EditProfileForm
                            form={editProfileFormName}
                            onSubmit={this.saveProfile}
                        />
                    </Grid>
                </Grid>
            </div>
        );
    }
}

const mapStateToProps = (state: ReduxState): IProfilePageEditReduxProps => {
    const selector = formValueSelector(editProfileFormName);
    const selectedValues: EditProfileData = selector(
        state,
        "phoneNumber",
        "email"
    );
    return {
        name: `${state.profile.firstName} ${state.profile.lastName}`,
        phoneNumber: state.profile.phoneNumber || "",
        email: state.profile.email || "",
        hasUserName: !!state.user.username,
        isSaveButtonDisabled: actionButtonDisabled(state),
        isSaveClicked: actionButtonClicked(state),
        formValues: selectedValues,
    };
};

const mapDispatchToProps = (
    dispatch: ReduxDispatch
): IProfilePageEditDispatchProps => {
    return {
        submitProfileForm: async () => {
            logger.log("submit");
            await dispatch(submit(editProfileFormName));
        },
        setHeader: (value: string) => {
            dispatch(SetHeader(value));
        },
        setBackButton: (route: string) => {
            dispatch(ShowBackNavigationWithRoute(route));
        },
        hideBackButton: () => {
            dispatch(SetShowBackNavigation(false));
        },
        setActionButton: (button: ActionButton) => {
            dispatch(SetActionButtonAndShow(button));
        },
        hideActionButton: () => {
            dispatch(SetShowActionButton(false));
        },
        resetActionButtonClick: () => {
            dispatch(ResetActionButtonClicked());
        },
        disableActionButton: (disabled: boolean) => {
            dispatch(SetActionButtonDisabled(disabled));
        },
        saveProfileData: async (data: IProfileDataDto) => {
            dispatch(saveProfileData(data));
        },
        fetchProfile: () => {
            dispatch(fetchProfileData());
        },
    };
};

export default connect<
    IProfilePageEditReduxProps,
    IProfilePageEditDispatchProps,
    IProfilePageEditProps
>(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(EditProfilePage));



// WEBPACK FOOTER //
// ./src/views/profile/EditProfilePage.tsx